import { render } from "./TemplateNew.vue?vue&type=template&id=3bfeac39&ts=true"
import script from "./TemplateNew.vue?vue&type=script&lang=ts"
export * from "./TemplateNew.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__